import { Controller } from 'stimulus'
import { pendingCalendarEventFetchCount } from '~/common/components/calendar/event_store'

export default class extends Controller {
  connect() {
    if (pendingCalendarEventFetchCount() > 0) this.show()
  }

  show() {
    this.element.classList.remove('opacity-0', 'pointer-events-none')
  }

  hide() {
    this.element.classList.add('opacity-0', 'pointer-events-none')
  }
}
